var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup22(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 50,
    viewBox: "0 0 75 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0936 49.8708H0V25.5186H11.0936V49.8708ZM1.4951 48.375H9.59849V27.0144H1.4951V48.375Z",
    fill: "#209BB7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.692 49.8713H9.59839V3.11133H20.692V49.8713ZM11.0935 48.3754H19.1969V4.60717H11.0935V48.3754Z",
    fill: "#209BB7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0352 49.8712H26.9417V33.9854H38.0352V49.8712ZM28.4367 48.3753H36.5401V35.4812H28.4367V48.3753Z",
    fill: "#209BB7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6038 49.8711H36.5103V19.8945H47.6038V49.8711ZM38.0053 48.3753H46.1087V21.3904H38.0053V48.3753Z",
    fill: "#209BB7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9469 49.8712H53.8533V11.6675H64.9469V49.8712ZM55.3484 48.3754H63.4518V13.1633H55.3484V48.3754Z",
    fill: "#209BB7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5155 49.8713H63.4219V0H74.5155V49.8713ZM64.917 48.3754H73.0204V1.49584H64.917V48.3754Z",
    fill: "#209BB7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup22);
export default __webpack_public_path__ + "static/media/Group22.e917cb01f8de46b94979793533ed1f72.svg";
export { ForwardRef as ReactComponent };